export const BASE_SCAN_CHECK_INCREMENT = 1000;
